import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierOutlinerIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M13 15H23C23.55 15 24 14.55 24 14V8C24 7.45 23.55 7 23 7H13C12.45 7 12 7.45 12 8V10H6V6H9C9.55 6 10 5.55 10 5V1C10 0.45 9.55 0 9 0H1C0.45 0 0 0.45 0 1V5C0 5.55 0.45 6 1 6H4V20C4 20.55 4.45 21 5 21H12V23C12 23.55 12.45 24 13 24H23C23.55 24 24 23.55 24 23V17C24 16.45 23.55 16 23 16H13C12.45 16 12 16.45 12 17V19H6V12H12V14C12 14.55 12.45 15 13 15ZM14 9H22V13H14V9ZM2 4V2H8V4H2ZM14 18H22V22H14V18Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierOutlinerIcon.displayName = 'HierOutlinerIcon';
